import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
import * as moment from 'moment';
import 'moment/locale/pt-br';

// Service
import { HolidaysInsertService } from '../../service/holidays-insert/holidays-insert.service';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-holidays',
  templateUrl: './holidays-insert.component.html',
  providers: [
    HolidaysInsertService,
    HttpModule
  ]
})

export class HolidaysInsertComponent implements OnInit {

  private token;
  public holidays: any[] = [];
	holiday: FormGroup;
	
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels:{su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		//inline: true,
		height: "30px"
	};

  constructor(fb: FormBuilder, private holidaysInsertService: HolidaysInsertService, private flashMessagesService: FlashMessagesService, private router: Router) { 
    this.token = localStorage.getItem('yara.token');
    this.holiday = fb.group({
			'DataFeriado':  ['',Validators.required],
			'Descricao': ['',Validators.required]
		});
	}

  ngOnInit() {
    this.getHolidays();
  }

  getHolidays() {
		this.holidaysInsertService.getHolidays(this.token).subscribe(result => {
			if (result.Success) {
				this.holidays = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	insertHoliday(value: any) {

		var newHoliday = {
			DataFeriado: moment(value.DataFeriado.jsdate).format("YYYY-MM-DD HH:mm:ss"),
			Descricao: value.Descricao,
			Ativo: true
		}

		this.holidaysInsertService.insertHoliday(this.token, newHoliday).subscribe(result => {
				if (result.Success) {
					this.flashMessagesService.show('Feriado cadastrado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
					this.holiday.reset();
					this.getHolidays();
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
				
		});
	}

	removeHoliday(id) {
		this.holidaysInsertService.removeHoliday(this.token, id).subscribe(result => {
				if (result.Success) {
					this.flashMessagesService.show('Feriado removido com sucesso', { cssClass: 'alert-success', timeout: 6000 });
					this.getHolidays();
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
				
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/holidays/component/holidays-insert/holidays-insert.component.ts